import { SCHEMA_URIS } from './schemas'
export const hotspotBlinkySchema = {
  id: SCHEMA_URIS.HOTSPOT_BLINKY,
  type: 'object',
  properties: {},
  required: [],
  additionalProperties: false,
  default: {}
}
